var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.campaign
    ? _c(
        "div",
        {
          staticClass:
            "w-full booking-campaign-banner flex align-center margin-t-5",
        },
        [
          _c("div", { staticClass: "flex align-center" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "margin-l-1" }, [
              _vm._v("Part of campaign: " + _vm._s(_vm.campaign.name)),
            ]),
          ]),
          _vm._v(" "),
          _vm.$userIsAdmin
            ? _c(
                "router-link",
                {
                  staticClass: "margin-r-2",
                  attrs: {
                    to: {
                      name: "campaign.edit",
                      params: { id: _vm.campaign.id },
                    },
                  },
                },
                [
                  _c("span", [
                    _vm._v("View Campaign "),
                    _c("i", { staticClass: "fa fa-chevron-right" }),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "booking-campaign-banner__icon spacer-x-2 spacer-y-2" },
      [_c("i", { staticClass: "fa fa-1x fa-clone" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }